/**
 * mandalas — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const mandalasPack: ToilePack = {
    slug: 'mandalas',
    category: 'mandalas',
    name: 'Mandalas',
    tagline: tagline('mandalas', 'motifs', 'treatments'),
    chips: chips('motifs', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'floral', label: 'Floral', subject: 'lotus petals, rose blooms, leaf fans and vine scrolls'},
        {key: 'geometric', label: 'Geometric', subject: 'interlocking triangles, hexagons, arcs and star polygons'},
        {key: 'animal', label: 'Animal motif', subject: 'repeating elephants, peacock feathers, butterflies and fish'},
    ],
    styles: [
        {key: 'coloring', label: 'Coloring page', style: 'fine-line, closed uniform stroke, open areas to color', palette: 'black line only, pure white ground', framing: 'circular, radially symmetrical, centered'},
        {key: 'dotwork', label: 'Dotwork', style: 'built from stipple dots of varying density, no outlines', palette: 'black dots, pure white ground', framing: 'circular, radially symmetrical, centered'},
        {key: 'color', label: 'Layered color', style: 'jewel tones layered ring by ring, gold outlines', palette: 'saturated on a deep indigo ground', framing: 'circular, radially symmetrical, centered'},
    ],
    directions: ['a moon and stars motif', 'fewer rings, more open space', 'inside a square border'],
}
